import {$, w} from './constants';

const MOBILE = '(max-width: 950px)';
function isMobile(){ return window.matchMedia(MOBILE).matches; }

function toggleVideo(){
  const $bg = $('.yt-bg');
  const $wrap = $('.yt-bg-wrap');

  // Solo cargar el iframe en desktop
  if (!isMobile()) {
    const src = $bg.data('src');
    if (src) $bg.attr('src', src);
    $wrap.removeClass('mobile-mode');
  } else {
    // Si es mobile, mostramos solo la imagen
    $wrap.addClass('mobile-mode');
    $bg.attr('src', '');
  }
}

$(document).ready(function() {
  toggleVideo();
});

$(w).on('resize', function(){
  toggleVideo();
})
$(document).on('click', '.show_live_video', function(e){
  e.preventDefault();

  const $section    = $(this).closest('.home__hero');
  const $playerWrap = $section.find('.yt-player-wrap');
  const $player     = $section.find('.yt-player');
  const $bg         = $section.find('.yt-bg');

  // Detener background
  if ($bg.length) $bg.attr('src', '');

  // Cargar el player de verdad
  const src = $player.data('src');
  if (src && !$player.attr('src')) {
    $player.attr('src', src);
  }

  $section.addClass('is-live');
  $playerWrap.removeAttr('hidden');
});

/* Light YouTube Embeds by @labnol */
/* Web: http://labnol.org/?p=27941 */
export function initYT() {
    var div, n;
    var v_2 = document.getElementsByClassName("youtube-player-2");

    for (n = 0; n < v_2.length; n++) {
        div = document.createElement("div");
        div.classList.add('player');
        div.setAttribute("data-id", v_2[n].dataset.id);
        div.innerHTML = labnolThumbCustom(v_2[n].dataset.id, v_2[n].dataset.image);
        div.onclick = labnolIframe;
        v_2[n].appendChild(div);
    }
}

function labnolThumb(id) {
    const max = `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;
    const fallback = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;

    const thumb = `
        <img 
            src="${max}" 
            onerror="this.onerror=null;this.src='${fallback}';"
            alt=""
        >
    `;
    const play = '<div class="play"></div>';

    return thumb + play;
}

function labnolThumbCustom(id, img) {
    const max = `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;
    const fallback = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
    const src = img || max;

    const thumb = `
        <img 
            src="${src}" 
            onerror="this.onerror=null;this.src='${fallback}';"
            alt=""
        >
    `;

    const play = '<div class="play-video-terminal"></div>';

    return thumb + play;
}

function labnolIframe() {
    var iframe = document.createElement("iframe");
    var embed = "https://www.youtube.com/embed/ID?autoplay=1";  // Agrega autoplay=1 para reproducción automática
    iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "1");
    iframe.setAttribute("allow", "autoplay");  // Necesario para permitir autoplay en algunos navegadores
    this.parentNode.replaceChild(iframe, this);
}